import { render, staticRenderFns } from "./theToolbar.vue?vue&type=template&id=5dc412b0&scoped=true&"
import script from "./theToolbar.vue?vue&type=script&lang=js&"
export * from "./theToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc412b0",
  null
  
)

export default component.exports